module.exports = __webpack_public_path__ + "media/partner_pc1.4c8f0f7c.mp4";